const styles = (theme) => ({
  wrap: {
    padding: theme.spacing(2.5),
  },
  original: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(2.5, 0),
  },
  type: {
    marginBottom: theme.spacing(2.5),
  },
  inputSet: {
    textAlign: 'right',
    marginBottom: theme.spacing(5),
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-end',
    '& span': {
      marginRight: theme.spacing(1),
    },
  },
  inputLabel: {
    left: 'auto',
    right: 0,
  },
  inputLabelWithPercent: {
    left: 'auto',
    right: theme.spacing(2),
  },
  errorMessage: {
    height: 20,
  },
});

export default styles;
